/** 仅保留数字（纯数字 / number） */
export function sanitizeNumber(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * 小数过滤：最多一个 `.`，可选限制小数位。
 * 允许输入过程中间态：`""`、`"1."`、`"."`（会规范为 `"0."`）。
 */
export function sanitizeDecimal(value: string, decimalPlaces?: number): string {
  let cleaned = value.replace(/[^\d.]/g, '');
  const firstDot = cleaned.indexOf('.');
  if (firstDot !== -1) {
    cleaned =
      cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
  }

  if (cleaned.startsWith('.')) {
    cleaned = `0${cleaned}`;
  }

  if (decimalPlaces != null && Number.isFinite(decimalPlaces)) {
    const places = Math.max(0, Math.floor(decimalPlaces));
    if (places === 0) {
      const dot = cleaned.indexOf('.');
      return dot === -1 ? cleaned : cleaned.slice(0, dot);
    }
    const dot = cleaned.indexOf('.');
    if (dot !== -1) {
      cleaned = cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1, dot + 1 + places);
    }
  }

  return cleaned;
}

/** 资金/金额默认保留 2 位小数 */
export const DEFAULT_MONEY_DECIMAL_PLACES = 2;

export function resolveDecimalPlaces(
  inputKind?: string,
  decimalPlaces?: number,
): number | undefined {
  if (decimalPlaces != null && Number.isFinite(decimalPlaces)) {
    return Math.max(0, Math.floor(decimalPlaces));
  }
  if (inputKind === 'amount' || inputKind === 'fund') {
    return DEFAULT_MONEY_DECIMAL_PLACES;
  }
  return undefined;
}

/** 失焦规范化：去掉末尾 `.` */
export function normalizeDecimalOnBlur(value: string): string {
  return value.replace(/\.$/, '');
}

export function validateNumber(value: string): boolean {
  return /^\d+$/.test(value);
}

/** 完整小数校验；允许整数；若指定小数位则校验小数部分长度 */
export function validateDecimal(value: string, decimalPlaces?: number): boolean {
  const trimmed = value.trim();
  if (!/^\d+(\.\d+)?$/.test(trimmed)) return false;
  if (decimalPlaces == null || !Number.isFinite(decimalPlaces)) return true;
  const places = Math.max(0, Math.floor(decimalPlaces));
  const dot = trimmed.indexOf('.');
  if (places === 0) return dot === -1;
  if (dot === -1) return true;
  return trimmed.length - dot - 1 <= places;
}
